export var networkUpdates = [
    {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1485586863000,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "01/28/2017",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "eventTriggerFirstName": "Fast",
        "eventTriggerLastName": "SSD",
        "eventRecieverFirstName": "Abarth",
        "eventRecieverLastName": "Punto",
        "eventReceiverEduIns": "Blue Cliff Career College",
        "eventReceiverCampus": "Tuscany",
        "eventReceiverSubject": "Automobile Engineering",
        "courseName": null,
        "topicName": null,
        "jobName": null,
        "educationalInstitution": null,
        "campus": null,
        "starRatingCount": null,
        "netowrkUpdateEventType": "ACCEPT_INVITATION_REQUEST",
        "eventTriggerGender": "M",
        "observerUserId": null,
        "eventReceiverUserId": 43,
        "eventTriggerUserId": 42,
        "eventId": null,
        "eventTriggerProfilePicImageURL": null
    },
    {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1485786659000,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "01/30/2017",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "eventTriggerFirstName": "Abarth",
        "eventTriggerLastName": "Punto",
        "eventRecieverFirstName": "Abarth",
        "eventRecieverLastName": "Punto",
        "eventReceiverEduIns": "Blue Cliff Career College",
        "eventReceiverCampus": "Tuscany",
        "eventReceiverSubject": "Automobile Engineering",
        "courseName": null,
        "topicName": null,
        "jobName": null,
        "educationalInstitution": null,
        "campus": null,
        "starRatingCount": null,
        "netowrkUpdateEventType": "ACCEPT_RECOMMENDATION_RESPONSE",
        "eventTriggerGender": "M",
        "observerUserId": null,
        "eventReceiverUserId": 43,
        "eventTriggerUserId": 43,
        "eventId": null,
        "eventTriggerProfilePicImageURL": "https://s3.amazonaws.com/uvsityImages/profilebig.png"
    },
    {
        "startIndex": 0,
        "noOfRowsToFetch": 0,
        "mapOfAdditinalParams": null,
        "createdBy": "ANONYMOUS",
        "createdOn": 1485786907000,
        "lastUpdatedBy": null,
        "lastUpdatedOn": null,
        "expiryOn": null,
        "createdOnDateForDisplay": "01/30/2017",
        "createdOnDateInDDMmYYYFormat": null,
        "formattedCreatedDateForDisplay": null,
        "formattedUpdatedDateForDisplay": null,
        "eventTriggerFirstName": "Abarth",
        "eventTriggerLastName": "Punto",
        "eventRecieverFirstName": "Abarth",
        "eventRecieverLastName": "Punto",
        "eventReceiverEduIns": "Blue Cliff Career College",
        "eventReceiverCampus": "Tuscany",
        "eventReceiverSubject": "Automobile Engineering",
        "courseName": null,
        "topicName": null,
        "jobName": null,
        "educationalInstitution": null,
        "campus": null,
        "starRatingCount": null,
        "netowrkUpdateEventType": "REJECT_RECOMMENDATION_RESPONSE",
        "eventTriggerGender": "M",
        "observerUserId": null,
        "eventReceiverUserId": 43,
        "eventTriggerUserId": 43,
        "eventId": null,
        "eventTriggerProfilePicImageURL": "https://s3.amazonaws.com/uvsityImages/profilebig.png"
    }
];
//# sourceMappingURL=networkUpdates.js.map